/**
 * description: 内容管理
 * dateTime: 2024/8/22-上午10:19
 * author: ZhangJun 1580043700@qq.com
 */

import request, {METHODS} from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

// 内容分类列表
export const queryContentInfoList =  (options:any) => {
    return request(`${UrlConfig.Content.queryContentInfoListByPage}`, {
        method: METHODS.POST,
        ...options,
    })
}

export const saveOrUpdateContentInfo =  (data:Record<string, any>) => {
    return request(`${UrlConfig.Content.saveOrUpdateContentInfo}`, {
        method: METHODS.PUT,
        data,
    })
}

export const deleteContentInfo =  (params:Record<string, any>) => {
    return request(`${UrlConfig.Content.deleteContentInfo}`, {
        method: METHODS.DELETE,
        params,
    })
}

export const queryContentInfo =  (id: string) => {
    return request(`${UrlConfig.Content.queryContentInfo}`, {
        method: METHODS.POST,
        params:{ id },
    })
}

export const cGrounding =  (data:Record<string, any>) => {
    return request(`${UrlConfig.Content.cGrounding}`, {
        method: METHODS.POST,
        data,
    })
}
export const appGrounding =  (params:Record<string, any>) => {
    return request(`${UrlConfig.Content.appGrounding}`, {
        method: METHODS.POST,
        params,
    })
}

// 查询内容C端分类树
export const queryCategoryList =  (data:Record<string, any>) => {
    return request(`${UrlConfig.Content.queryCategoryList}`, {
        method: METHODS.POST,
        data,
    })
}

// 内容分类列表
export const queryContentCategoryList =  (data:Record<string, any>) => {
    return request(`${UrlConfig.Content.queryContentCategoryList}`, {
        method: METHODS.POST,
        data,
    })
}

// 内容分类
export const addContentCategory =(data:Record<string, any>) => {
    return request(`${UrlConfig.Content.addContentCategory}`, {
        method: METHODS.PUT,
        data,
    })
}

// 内容分类
export const updateContentCategory = (data:Record<string, any>) => {
    return request(`${UrlConfig.Content.updateContentCategory}`, {
        method: METHODS.POST,
        data,
    })
}

// 内容分类
export const deleteContentCategory = (params:Record<string, any>) => {
    return request(`${UrlConfig.Content.deleteContentCategory}`, {
        method: METHODS.DELETE,
        params,
    })
}

// 内容分类
export const saveOrUpdateContentTag =(data:Record<string, any>) => {
    return request(`${UrlConfig.Content.saveOrUpdateContentTag}`, {
        method: METHODS.PUT,
        data,
    })
}

// 内容分类
export const queryContentTagList = (options:any) => {
    return request(`${UrlConfig.Content.queryContentTagListByPage}`, {
        method: METHODS.POST,
        ...options,
    })
}

// 内容分类
export const deleteContentTag = (params:Record<string, any>) => {
    return request(`${UrlConfig.Content.deleteContentTag}`, {
        method: METHODS.DELETE,
        params,
    })
}

export const queryBuildingInfoByEmployeeId = (options:any) => {
    return request(`${UrlConfig.Content.queryBuildingInfoByEmployeeId}`, {
        method: METHODS.POST,
        ...options,
    })
}

// 根据公司ID查询公司下的部门树
export const departmentTree = (companyId, data:any={}) => {

    return request(`${UrlConfig.Caas.departmentTree}${companyId}`, {
        method: METHODS.POST,
        data: data,
    })
}

